import * as React from "react";
const SvgFiRrBiohazard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-biohazard_svg__a)">
      <path
        fill="#062147"
        d="M9.032 4.501a1 1 0 0 1 .719-1.218 9.1 9.1 0 0 1 4.499 0 1 1 0 0 1-.5 1.936 7.1 7.1 0 0 0-3.5 0 1 1 0 0 1-1.218-.718M6.186 18.498a1.001 1.001 0 0 0 .728-1.687 7.05 7.05 0 0 1-1.694-3.065 1 1 0 0 0-1.936.5 9 9 0 0 0 2.175 3.937 1 1 0 0 0 .727.313zm13.809-5.436a1 1 0 0 0-1.222.713 7.042 7.042 0 0 1-1.707 3.058 1 1 0 0 0 1.448 1.379 9 9 0 0 0 2.193-3.928 1 1 0 0 0-.713-1.222m3.67-.315a1 1 0 0 1-1.324.005c-.312-.274-.5-.439-.725-.564a4.506 4.506 0 0 0-6.118 1.752 4.506 4.506 0 0 0 1.753 6.118c.24.134.692.27.99.36.483.146.806.635.72 1.132a1 1 0 0 1-1.005.838c-1.146-.051-2.322-.369-3.23-.872a7.6 7.6 0 0 1-2.716-2.602c-.705 1.088-1.653 2.001-2.736 2.602-.907.503-2.083.821-3.23.872H6a1 1 0 0 1-.288-1.957c.346-.104.797-.24 1.039-.374a4.505 4.505 0 0 0 1.752-6.118 4.504 4.504 0 0 0-6.118-1.752c-.226.125-.413.29-.65.499-.38.334-.982.365-1.361.029-.377-.335-.482-.867-.196-1.283.659-.958 1.414-1.664 2.307-2.16a7.9 7.9 0 0 1 3.237-.954c-.466-1.082-.72-2.232-.72-3.319s.245-2.14.729-3.113a1 1 0 0 1 1.873.655 4.505 4.505 0 0 0 4.398 5.457A4.505 4.505 0 0 0 16.4 2.541a1 1 0 0 1 1.873-.655c.484.973.729 2.02.729 3.113s-.254 2.236-.72 3.317a7.9 7.9 0 0 1 3.237.956c.893.496 1.647 1.202 2.307 2.16a1 1 0 0 1-.16 1.314zM14 12A2 2 0 1 0 10 11.999 2 2 0 0 0 14 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-biohazard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBiohazard;
